import { LocalDate } from "@js-joda/core";

//! @ngInject
export function approvePatientDocumentModalCtrl ($scope, $uibModalInstance, DatabaseApi, toaster, apiErrors, dateUtils) {
      $scope.form = {
        approvedDate: dateUtils.ymdStringToDate(LocalDate.now().toJSON()),
        sendToEmailsText: "",
      };

      // Documents without a document type (custom scanned uploads) have no
      // "Approval Emails" setting, so let the user enter recipients manually
      const document = $scope.$resolve.document;
      $scope.showSendToEmails = (document.documentTypeId ?? document.documentType ?? null) === null;

      $scope.submit = () => {
        if ($scope.form.approvedDate === null) {
          toaster.pop("error", "Error", "Please select a date");
        }

        const sendToEmails = ($scope.form.sendToEmailsText || "")
          .split(",")
          .map((email) => email.trim())
          .filter((email) => email !== "");
        if (sendToEmails.some((email) => !/^\S+@\S+\.\S+$/.test(email))) {
          toaster.pop("error", "Invalid email address", "Use a comma separated list of emails");
          return;
        }

        const body = {
          approvedDate: dateUtils.dateToLocalDate($scope.form.approvedDate),
          ...(sendToEmails.length > 0 ? { sendToEmails } : {}),
        };

        const url =
          "agencies/:agencyId/agency_members/:agencyMemberId/patient_documents/:patientDocumentId/mark_as_approved"
            .replace(":agencyId", $scope.agencyId)
            .replace(":agencyMemberId", $scope.agencyMemberId)
            .replace(":patientDocumentId", $scope.$resolve.document.id);

        $scope.isLoading = true;
        DatabaseApi.put(url, body)
          .then((response) => {
            $scope.$resolve.onSuccess?.(response.data.document);
            toaster.pop("success", "Success", "Marked as approved");
            $uibModalInstance.close();
          })
          .catch((error) => {
            console.error(error);
            toaster.pop(
              "error",
              "Something went wrong",
              apiErrors.format(error, "Failed to sign physician document")
            );
          })
          .finally(() => ($scope.isLoading = false));
      };

      $scope.close = () => {
        $uibModalInstance.close();
      };
    }
